import styled from "styled-components";

export const TwoColumns = styled.div`
  display: flex;
  gap: 1rem;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 3rem;
  }
`;

export const TwoColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const HeroWrap = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 28rem;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 28rem;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const Overheading = styled.label`
  font-size: 0.75rem;
  line-height: 1.75rem;
  letter-spacing: 0.2ch;
  font-family: "Oswald", sans-serif;
  text-transform: uppercase;
  color: #9e9e9e;
`;

export const HeroHeadingWrap = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 25rem;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 0.5rem;
`;

export const HeroH1 = styled.h1`
  margin: 0;
  font-size: 2.25rem;
  line-height: 2.5rem;
  font-family: "Oswald", sans-serif;
  font-weight: 600;
`;

export const HeroDescription = styled.p`
  width: 75%;
  margin-top: 1.5rem;
  font-size: 1rem;
  line-height: 1.25rem;
`;

export const DownloadWrap = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  align-items: center;
  margin-top: 1rem;

  @media (max-width: 480px) {
    flex-direction: row;
  }
`;

export const BannerWrap = styled.div`
  display: flex;
  position: relative;
  padding-right: 1rem;
`;

export const BannerLink = styled.a`
  display: inline-block;
  overflow: hidden;

  &:hover {
    opacity: 85%;
  }
`;

export const Image = styled.img`
  height: auto;
  width: 100%;
  object-fit: contain;
`;

export const BannerImg = styled.img`
  height: 2.5rem;

  @media (max-width: 768px) {
    height: 3.125rem;
  }
`;

export const HeroImageWrap = styled.div`
  display: flex;
  flex-grow: 1;
  position: relative;
  min-width: 20px;
  min-height: 20px;
  max-width: 544px;
`;

export const Testimonials = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  align-self: stretch;
  padding: 2rem 0 2rem 0;
  @media (max-width: 480px) {
    align-items: center;
  }
`;

export const ThreeColumns = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const ThreeColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% / 3);
  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const TestimonialWrap = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 250px;
  justify-content: center;
  align-items: center;
`;

export const TestimonialIconWrap = styled.div`
  display: flex;
  max-width: 100px;
`;

export const TestimonialText = styled.p`
  margin-top: 0.5rem;
  font-size: 0.85rem;
  line-height: 1.5rem;
  text-align: center;
  font-weight: bold;
`;
